import {IncomingHttpHeaders} from "http"

const getLocaleFromHeaders = (headers: IncomingHttpHeaders) =>
    `${(headers["x-next-language"] as string) || ""}-${(headers["x-next-territory"] as string).toUpperCase()}`

export default getLocaleFromHeaders
